//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../../../media/MediaQuery";

//css
import styled from "styled-components";

// component
import BasicBtn from "../../../../component/button/BasicBtn";

// responsive
import { M, T } from "../../../../utils/MT";

export default function MyEdit() {
    //페이지 이동
    const navigate = useNavigate();
    const MyEditDetail = () => {
        navigate(`detail`);
    };

    // 로그인 창 액티브 스타일
    const [pwdText, setPwdText] = useState(false);

    return (
        <Wrap>
            <TitleWrap>
                <Title>개인정보수정</Title>
                <SubTitle>회원님의 정보를 안전하게 보호하기 위해 비밀번호를 다시 한번 확인해 주세요.</SubTitle>
            </TitleWrap>

            <ContentBigWrap>
                <ContentWrap>
                    {/* id */}
                    <InputWrap>
                        <InputTitle>아이디</InputTitle>
                        <TextInput type="text" defaultValue="sindoh1234" readOnly />
                    </InputWrap>
                    {/* pwd */}
                    <InputWrap>
                        <InputTitle>비밀번호</InputTitle>
                        <TextInput
                            active={pwdText.length > 0}
                            onChange={(e) => {
                                setPwdText(e.target.value);
                            }}
                            type="password"
                            placeholder="비밀번호를 입력해주세요."
                            required
                        />
                    </InputWrap>
                </ContentWrap>

                {/* 비밀번호 일치하지않을 시 해당 텍스트 노출해주세요! */}
                {/* <ErrorMsg>*비밀번호가 일치하지않습니다.</ErrorMsg> */}
            </ContentBigWrap>

            <BtnWrap>
                <BasicBtn
                    onClick={() => {
                        MyEditDetail();
                    }}
                    text="다음"
                />
            </BtnWrap>
        </Wrap>
    );
}

const Wrap = styled.div`
    position: relative;
    width: 100%;
    @media screen and (max-width: 900px) {
        width: ${M(378)};
        margin: 0 auto;
    }
`;

const TitleWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding-bottom: calc(100vw * (20 / 1920));
    border-bottom: 1px solid #000;

    @media screen and (max-width: 1300px) {
        padding-bottom: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding-bottom: ${M(20)};
    }
`;

const Title = styled.h3`
    font-size: calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
    }
`;

const SubTitle = styled.p`
    font-family: "Noto-R";
    font-size: calc(100vw * (15 / 1920));

    padding-left: calc(100vw * (10 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
        padding-left: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(200)};
        font-size: ${M(11)};
        padding-left: ${M(10)};
        word-break: keep-all;
        text-align: right;
    }
`;

const ContentBigWrap = styled.div`
    position: relative;
`;

const ContentWrap = styled.div`
    display: flex;
    align-items: center;
    padding: calc(100vw * (20 / 1920)) 0;

    border-bottom: 1px solid #ddd;

    margin-bottom: calc(100vw * (40 / 1920));

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;
        margin-bottom: calc(100vw * (40 / 1300));
    }

    @media screen and (max-width: 900px) {
        flex-direction: column;
        padding: ${M(30)} 0;
        margin-bottom: ${M(40)};
    }
`;

const InputWrap = styled.div`
    display: flex;
    align-items: center;

    &:last-child {
        margin-left: auto;

        @media screen and (max-width: 900px) {
            margin-top: ${M(15)};
            margin-left: unset;
        }
    }

    @media screen and (max-width: 900px) {
        flex-direction: column;
        width: 100%;
    }
`;

const InputTitle = styled.label`
    width: calc(100vw * (115 / 1920));
    font-size: calc(100vw * (15 / 1920));
    padding-left: calc(100vw * (6 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (115 / 1300));
        font-size: calc(100vw * (15 / 1300));
        padding-left: calc(100vw * (6 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        font-size: ${M(15)};
        padding-left: ${M(6)};
    }
`;

const TextInput = styled.input`
    width: calc(100vw * (280 / 1920));
    font-size: calc(100vw * (15 / 1920));

    padding: calc(100vw * (11 / 1920)) calc(100vw * (15 / 1920));
    background: #fafafa;
    border-radius: 4px;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (280 / 1300));
        font-size: calc(100vw * (15 / 1300));
        padding: calc(100vw * (11 / 1300)) calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        margin-top: ${M(10)};
        font-size: ${M(15)};
        padding: ${M(11)} ${M(15)};
    }

    ${({ active }) =>
        active &&
        `
            color:#222;
            border: 1px solid var(--main-color);
            background: #fff;
        `};
`;

const ErrorMsg = styled.p`
    position: absolute;
    top: calc(100% + 100vw * (10 / 1920));
    left: 0;

    font-size: calc(100vw * (14 / 1920));
    color: #ef0000;

    @media screen and (max-width: 1300px) {
        top: calc(100% + 100vw * (10 / 1300));
        font-size: calc(100vw * (14 / 1300));
    }

    @media screen and (max-width: 900px) {
        top: ${M(10)};
        font-size: ${M(14)};
    }
`;

const BtnWrap = styled.div`
    width: calc(100vw * (200 / 1920));
    margin: 0 auto;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (200 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(300)};

        & p {
            font-size: ${M(15)};
        }
    }
`;
